import { CLASSIC_VARIANT } from "../shared/controleVariants";
import { emptySection } from "../shared/controleConstants";
import { patientControlsForDossier } from "../shared/patientControlRules";

export function defaultFormData() {
    return {
        meta: {
            pharmacien: "",
            lancementHeure: "",
            nombreSachetsProduits: "",
            tempsProduction: "",
            nombrePatients: "",
            patientControle: "",
        },
        commentaires: {},
        controlePatients: {},
        remarquesPoint1: [],
        ...Object.fromEntries(CLASSIC_VARIANT.sections.map(section => [section.key, emptySection(section)])),
    };
}

export function mergeFormData(data) {
    return {
        ...defaultFormData(),
        ...(data || {}),
        meta: { ...defaultFormData().meta, ...(data?.meta || {}) },
        commentaires: { ...(data?.commentaires || {}) },
        controlePatients: { ...(data?.controlePatients || {}) },
        remarquesPoint1: Array.isArray(data?.remarquesPoint1) ? data.remarquesPoint1 : [],
    };
}

export function latestPatientControlDossier(dossiers, activeDossier, patientId, ehpadId) {
    return [...(dossiers || [])]
        .filter(dossier => dossier?.donnees?.meta?.dossierType !== "PRODUCTION_PDA")
        .filter(dossier => !activeDossier?.id || String(dossier.id) !== String(activeDossier.id))
        .filter(dossier => !ehpadId || String(dossier.ehpadId) === String(ehpadId))
        .filter(dossier => patientControlsForDossier(dossier, patientId))
        .sort((a, b) => String(b.dateProduction || "").localeCompare(String(a.dateProduction || ""))
            || String(b.updatedAt || "").localeCompare(String(a.updatedAt || ""))
            || (Number(b.id) || 0) - (Number(a.id) || 0))[0] || null;
}
